import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "items", "toggleable"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.itemsTarget.insertAdjacentHTML('beforeend', content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest('.nested-fields')
    if (wrapper) {
      const destroyField = wrapper.querySelector('input[name*="_destroy"]')
      if (destroyField) {
        destroyField.value = '1'
        wrapper.style.display = 'none'
      } else {
        wrapper.remove()
      }
    }
  }

  removeStatblock(event) {
    event.preventDefault()
    const wrapper = event.target.closest('.mb-4')
    if (wrapper) wrapper.remove()
  }

  toggle(event) {
    event.preventDefault()
    const target = this.toggleableTarget
    if (target) {
      target.classList.toggle('hidden')
    }
  }
} 